import React from 'react';
import { Drawer, Form, Button } from 'antd';

interface DrawerProps {
  width: number;
  visible: boolean;
  onClose: () => void;
  title: string;
  formComponent: React.ComponentType<any>; // Component form sẽ được truyền vào
  formProps: any; // Props truyền cho form
}

const GenericDrawer: React.FC<DrawerProps> = ({ width,visible, onClose, title, formComponent: FormComponent, formProps }) => {
  return (
    <Drawer
      width={width?? 500}
      title={title}
      open={visible}
      onClose={onClose}
    >
      <FormComponent {...formProps} />
    </Drawer>
  );
};

export default GenericDrawer;